// extracted by mini-css-extract-plugin
export default {"main":"MenuSortBy_main__YzaJN","menu":"MenuSortBy_menu__TQgTJ","selected":"MenuSortBy_selected__tgmZQ","button":"MenuSortBy_button__b+TuF"};